import React from "react";

import {
    Box,
    Breadcrumbs,
    Card,
    CardContent,
    CssBaseline,
    Grid,
    Link, ListItem,
    Stack,
    ThemeProvider,
    Typography
} from "@mui/material";
import {lightTheme} from "./Themes";
import {Portada} from "./components/Portada";
import {TopBar} from "./components/TopBar";
import {NavigationMenu} from "./components/NavigationMenu";
import {BottomBanner} from "./components/BottomBanner";
import {Skyline} from "./components/Skyline";
import {globalMaxWidth} from "./GlobalConfigs";
import {CalendarMonth} from "@mui/icons-material";

function BreadcrumbSection() {
    return (
        <Breadcrumbs aria-label="breadcrumb" margin={2}>
            <Link underline="hover" color="inherit" href="/">
                Home
            </Link>
            <Typography sx={{ color: 'text.primary' }}>Contacto</Typography>
        </Breadcrumbs>
    );
}

function Contents(){
    return (
        <Stack margin={2} sx={{
            maxWidth: globalMaxWidth,
            width: '80%'
        }}>
            <Grid container alignItems="center" justifyContent='space-evenly' spacing={4}>
                <Grid item size={2}>

                    <Card variant='outlined' sx={{
                        borderRadius: '15px',
                        boxShadow: 5,
                        width: 1,
                        maxWidth: globalMaxWidth,
                        backgroundColor: 'secondary.main'
                    }}>
                        <CardContent>
                            <Stack alignItems='left' spacing={2} sx={{
                                m: {lg: 2, xs: 1},
                            }}>
                                <Typography variant='h5' color='white'>
                                    <strong>Secretaría técnica</strong>
                                </Typography>
                                <Typography variant="body1" color='white'>
                                    <br/>
                                    Email: secretariaursi26@viajeseci.es
                                    <br/>
                                </Typography>
                            </Stack>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item size={2}>
                    <Card variant='outlined' sx={{
                        borderRadius: '15px',
                        boxShadow: 5,
                        width: 1,
                        maxWidth: globalMaxWidth,
                        backgroundColor: 'secondary.main'
                    }}>
                        <CardContent>
                            <Stack alignItems='left' spacing={2} sx={{
                                m: {lg: 2, xs: 1},
                            }}>
                                <Typography variant='h5' color='white'>
                                    <strong>Secretaría científica</strong>
                                </Typography>
                                <Typography variant="body1" color='white'>
                                    <br/>
                                    Email: congresoursi2026@ull.edu.es
                                    <br/>
                                </Typography>
                            </Stack>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>

        </Stack>
    )
}

function LegalPage() {
    return (
        <ThemeProvider theme={lightTheme}>
            <div className="App">
                <CssBaseline/>
                <Stack alignItems='center'>
                    <TopBar/>
                    <NavigationMenu/>
                    <Portada with_buttons={false} construction_text={false}/>
                    <BreadcrumbSection/>
                    <Contents/>
                    <Skyline/>
                    <BottomBanner/>
                </Stack>
            </div>
        </ThemeProvider>
    )
}

export default LegalPage;
